<script setup lang="ts">
import { TheMobileNavbar, TheNavbar, TheSnackbar } from '~/components';
import { comingSoonPages } from '@/enums/ComingSoon';

const route = useRoute();
</script>

<template>
  <v-layout class="app-layout">
    <TheMobileNavbar />
    <TheNavbar class="navbar" />
    <v-main class="main-content">
      <div class="content-wrapper">
        <NuxtPage class="page-content" :page-key="(route) => route.fullPath" />
      </div>
      <TheSnackbar />
    </v-main>
  </v-layout>
</template>

<style lang="scss" scoped>
.app-layout {
  display: block;
  height: 100vh;
  background: #f5f5f9; // Clean light background like Vuexy
  overflow: hidden;
}

.main-content {
  padding-left: 0 !important;
  padding-top: 75px !important;
  height: 100vh;
  background: transparent;
  overflow-y: auto; // Scroll at main content level like Vuexy
  overflow-x: hidden;

  @media (min-width: 768px) {
    padding-left: 284px !important; // Sidebar (260px) + left space (24px) like Vuexy
    padding-top: 24px !important; // Top space like Vuexy
    padding-right: 24px !important; // Right space like Vuexy
    padding-bottom: 0 !important; // No bottom space like Vuexy
  }
  
  // Custom scrollbar for main content
  &::-webkit-scrollbar {
    width: 6px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover::-webkit-scrollbar {
    opacity: 1;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(165, 163, 174, 0.3);
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(165, 163, 174, 0.5);
    border-radius: 3px;
    
    &:hover {
      background: rgba(165, 163, 174, 0.7);
    }
  }
}

.content-wrapper {
  max-width: none; // Remove max-width constraint
  margin: 0;
  padding: 0;
  height: auto; // Let content determine height
  overflow: visible; // No overflow control here
  
  @media (min-width: 768px) {
    padding: 0; // No additional padding
    height: auto;
  }
}

.page-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(58, 53, 65, 0.1);
  border: 1px solid rgba(76, 78, 100, 0.12);
  padding: 24px;
  height: auto; // Content determines height
  overflow: visible; // No internal scrolling
  margin-bottom: 24px; // Space at bottom for last card
  
  @media (min-width: 768px) {
    padding: 30px;
    margin-bottom: 0; // No bottom margin on desktop like Vuexy
  }
  
  @media (min-width: 1200px) {
    padding: 32px;
  }
}

// Enhanced responsive design
@media (max-width: 767px) {
  .main-content {
    padding-top: 85px !important;
    padding-left: 12px !important; // Minimal left space on mobile
    padding-right: 12px !important; // Minimal right space on mobile
  }
  
  .page-content {
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
  }
}

// Dark mode support
.v-theme--dark {
  .app-layout {
    background: #25293c; // Dark background
  }
  
  .page-content {
    background: #2f3349;
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  }
}
</style>
